/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React, { Suspense } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import Container from '@mui/material/Container';
import { Link } from 'react-router-dom'
import Divider from '@mui/material/Divider';
import { BsBuilding, BsPuzzleFill, BsShieldFill } from 'react-icons/bs';
import { GiArtificialHive } from 'react-icons/gi';


const FAQ = React.lazy(() => import('../shared/VideoInfo'));
const VideoInfo = React.lazy(() => import('../shared/Faq'));
const Testimonies = React.lazy(() => import('../shared/Testimonies'));


var cardStyle = {
  display: 'block',
  width: '100%',
  height: '100%',
  backgroundColor: 'transparent',
  border: '1px solid #cbcbcb61'
}


const Home = ( ) => {
  const { classes } = useStyles();
  console.log('classes',classes)
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <div>

          <Grid item className={classes.container} xs={12} sm={12} md={12}>

            <div className={classes.heroContent}>
              <Container className={classes.cardGrid} maxWidth="xl">
                <div >
                  <Typography className={classes.bigHeaderTypo}  >
                  {t('titles:wlc')} 
                  </Typography>
                  <Typography className={classes.bigHeadersubtitle} variant="h5"
                    style={{ color: "#666" }}  >
                    {t('titles:tagline')}
                  </Typography>
                  <Typography className={classes.bigSubHeaderTypo} variant="h5"
                    style={{ color: "#666" }}  >
                    {t('titles:tagdesc')}
                  </Typography>
                </div>
              </Container>
            </div>
          </Grid>
          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700">

            <Grid item xs={12} sm={12} md={12} className={classes.containerWhiteBG}>


              <div >
                <Grid container spacing>
                  <Grid item xs={12} sm={6} md={6} style={{ paddingTop: '5%' }} >
                    <Typography variant="h1" align="center" style={{ color: "black" }} paragraph>
                    {t('titles:waw')} 
                    </Typography>
                    <div className={classes.sectionTitleBorder}></div>

                    <Typography variant="h3" align="center" style={{ color: "#748494", lineHeight: '1.75', paddingTop: '10px' }} paragraph>
                    {t('descp:waw')}    
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className={classes.containerDotBG}>
                    <img src="/assets/images/bg/laptop.png" className={classes.imageDotedDescp} alt="" />
                  </Grid>
                </Grid>

              </div>
            </Grid>
          </div>
          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700" id="services">

            <Grid item xs={12} sm={12} md={12} className={classes.cotainerListIfo}  >
              <Typography variant="h1" align="center" style={{ color: "black", marginTop: '100px' }} paragraph>
              {t('titles:ourservices')}  
              </Typography>
              <div className={classes.sectionTitleBorder}></div>
              <div className={classes.divinfoNavigation}>
                <Container className={classes.cardGrid} maxWidth="xl">
                  {/* End hero unit */}
                  <Grid container spacing={4}>


                    <Grid item xs={12} sm={12} md={3}>
                      <Card className={classes.cardService} style={cardStyle}>

                        <div className={classes.IconsDivInfoHolder}>
                          <BsBuilding className={classes.IconsDivInfo} />
                        </div>
                        <Link to="/enterprise" className={classes.link}>
                          <CardContent className={classes.cardContent}>

                            <Typography className={classes.blocksTypo} gutterBottom variant="h2" color="textPrimary">
                              {t('titles:enterprise')}
                            </Typography>
                            <Divider className={classes.divider} />

                            <Typography className={classes.blocksTypoInfo} variant="h3">
                              {t('subtitles:enterprise')}
                            </Typography>
                          </CardContent>
                        </Link>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <Card className={classes.cardService} style={cardStyle}>
                        <CardContent className={classes.cardContent}>
                          <div className={classes.IconsDivInfoHolder}>
                            <BsShieldFill className={classes.IconsDivInfo} />
                          </div>
                          <Link to="/digitalassets" className={classes.link}>

                            <Typography className={classes.blocksTypo} gutterBottom variant="h2" color="textPrimary">
                              {t('titles:digitalassets')}
                            </Typography>
                            <Divider className={classes.divider} />

                            <Typography className={classes.blocksTypoInfo} variant="h3">
                              {t('subtitles:digitalassets')}
                            </Typography>
                          </Link>
                        </CardContent>

                      </Card>
                    </Grid>


                    <Grid item xs={12} sm={6} md={3}>
                      <Card className={classes.cardService} style={cardStyle}>

                        <div className={classes.IconsDivInfoHolder}>
                          <BsPuzzleFill className={classes.IconsDivInfo} />
                        </div>
                        <Link to="/customsolutions" className={classes.link}>
                          <CardContent className={classes.cardContent}>
                            <Typography className={classes.blocksTypo} gutterBottom variant="h2" color="textPrimary">
                              {t('titles:customsolutions')}
                            </Typography>
                            <Divider className={classes.divider} />

                            <Typography className={classes.blocksTypoInfo} variant="h4">
                              {t('subtitles:customsolutions')}
                            </Typography>
                          </CardContent>
                        </Link>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <Card className={classes.cardService} style={cardStyle}>

                        <div className={classes.IconsDivInfoHolder}>
                          <GiArtificialHive className={classes.IconsDivInfo} />
                        </div>
                        <Link to="/artificialintelligence" className={classes.link}>
                          <CardContent className={classes.cardContent}>
                            <Typography className={classes.blocksTypo} gutterBottom variant="h2" color="textPrimary">
                              {t('titles:artificialintelligence')}
                            </Typography>
                            <Divider className={classes.divider} />

                            <Typography className={classes.blocksTypoInfo} variant="h4">
                              {t('subtitles:artificialintelligence')}
                            </Typography>
                          </CardContent>
                        </Link>
                      </Card>
                    </Grid>
                  </Grid>
                </Container>
              </div>
            </Grid>
          </div>
          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700" id="about">

            <Grid container spacing={4}>
              <Grid item xs={12} sm={6} md={6} className={classes.containerDotBG} >
                <img src="/assets/images/bg/work.png" className={classes.imageDescp} alt="" />
              </Grid>
              <Grid item xs={12} sm={6} md={6} >
                <Typography variant="h2" align="center" style={{ color: "black", marginTop: '10%', marginBottom: '20px' }} paragraph>
                {t('titles:aboutus')}
                </Typography>
                <div className={classes.sectionTitleBorder}></div>
                <div style={{ marginTop: '5%' }} >

                  <Typography variant="h3" align="center" style={{ color: "#748494", lineHeight: '1.75' }} paragraph>
                  {t('descp:hopePAgeAboutus')}

                    
                  </Typography>
                </div>
                <Button
                  component={Link}
                  to="/about"
                  variant="contained"
                  className="AlignCenter"
                >
                  {t('titles:learnMore')}
                </Button>
              </Grid>

            </Grid>

          </div>
          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700">

            <Grid item xs={12} sm={12} md={12} className={classes.cotainerListIfo}>
              <Suspense fallback={<div>Loading....</div>}>

                <Testimonies />
              </Suspense>

            </Grid>

          </div>
          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700" id="faq">

            <Grid item xs={12} sm={12} md={12} style={{ padding: '20px' }}>
              <Suspense fallback={<div>Loading....</div>}>

                <VideoInfo />
              </Suspense>
            </Grid>

          </div>

          <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700" id="faq">

            <Grid item xs={12} sm={12} md={12} style={{ padding: '20px' }}>
              <Suspense fallback={<div>Loading....</div>}>

                <FAQ />
              </Suspense>

            </Grid>

          </div>
        </div>
      </main>



    </React.Fragment >
  );
}

const useStyles = makeStyles({ "name": { Home } })((theme) => ({
  root: {
    display: 'flex',
  },
  CardActions: {
    padding: '10px',
    "&:hover + $toggledElement": {
      backgroundColor: "black",
      display: "block"
    }
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  imageDescp: {
    width: '65%;',
    padding: '1%',
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  imageDotedDescp: {
    width: '50%;',
    padding: '5%',
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {

    backgroundImage: `url(/assets/images/bg/clouds.jpg)`,

    maxHeight: '550px!important',


    position: 'relative',
    zIndex: '9',
    display: 'flex',
    alignItems: 'center',
    height: '100vh',
    padding: '50px 0',
    backgroundSize: 'cover',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    marginTop: '-60px',

    "&::before": {
      content: `''`,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      background: 'linear-gradient(90deg,rgba(3,15,39,.7) 0,rgba(3,15,39,0))'
    }
  },
  container: {

    paddingLeft: '0',
    paddingRight: '0',
    zIndex: '1',
    position: 'relative'
  },
  bigHeaderTypo: {

    fontSize: '72px!important',
    lineHeight: '1.2!important',
    color: '#fff!important',
    marginBottom: '40px!important',
    marginTop: '15%!important'
  },
  bigSubHeaderTypo: {

    fontSize: '20px!important',
    lineHeight: '1.67!important',
    color: '#fff!important',
    marginBottom: '40px!important',
    marginTop: '10px!important',

    fontWeight: '500'
  },
  bigHeaderImg: {
    height: '70px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block'
  },
  bigHeadersubtitle: {
    fontSize: '20px!important',
    color: 'white!important',
    width: 'fit-content'
  },

  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  cardService: {
    position: 'relative',
    display: 'block',
    padding: '10px 60px',
    transition: 'all .25s cubic- bezier(.645, .045, .355, 1)',
    borderRadius: '5px',
    zIndex: '99',
    backgroundColor: '#fff!important',
    "&:hover": {
      transform: 'scale(1.05)',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",

    }

  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    "&:hover": {
      background: '#efefef!important',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",
      borderRadius: '5px'
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },

  cotainerInfoNavigation: {
    marginTop: '100px',
    backgroundColor: '#F5F5F5',


  },

  divinfoNavigation: {

  },
  blocksTypo: {
    textAlign: 'center',
    color: '#383e56',
    paddingTop: '10px'

  },
  blocksTypoInfo: {
    textAlign: 'center',
    color: '#748494',
    paddingTop: '20px',
    fontSize: '18px!important'

  },
  divider: {
    backgroundColor: '#fb743e'
  },
  sectionTitleBorder: {
    width: '50px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',

  },
  IconsDivInfo: {
    fontSize: '2rem',

  },
  IconsDivInfoHolder: {
    width: '80px',
    padding: '20px',
    borderRadius: '50%',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    background: 'white',
    color: '#206aa7',

    "&:hover": {
      background: '#206aa7',
      color: 'white',
      transform: 'rotate(360deg)',
      transition: 'width 2s, height 2s, transform 2s'

    },

  },
  list: {
    color: 'black',
    marginTop: '50px!important'
  },
  subitemIList: {
    lineHeight: '1.7!important',

    "&::before": {
      backgroundColor: '#fb743e !important',
      content: `''`,
      borderRadius: '50%',
      width: '7px',
      height: '7px',
      position: 'absolute',
      left: '0',
      top: '20px'
    },


  },
  cotainerListIfo: {
    backgroundColor: '#f8faff',
    padding: '10px'
  },
  containerWhiteBG: {
    backgroundColor: '#fff!important',
    margin: '2%!important'
  },
  containerDotBG: {
    backgroundColor: '#fff!important',
    backgroundImage: 'radial-gradient(circle, #cbcbcb  20%, transparent 10%), radial-gradient(circle, #cbcbcb  20%, transparent 10%)',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 0, 50px 50px'
  }  
}));

export default  Home;